import { NgModule } from '@angular/core';
import {  AuthModule, CostCenterOccModule, ExternalRoutesModule, FeatureToggles, ProductModule, ProductOccModule, provideFeatureToggles, provideFeatureTogglesFactory, UserModule, UserOccModule } from "@spartacus/core";

declare module '@spartacus/core' {
  interface FeatureToggles {
    dispatchLoginActionOnlyWhenTokenReceived?: boolean;
  }
}
import {  BannerCarouselModule, BannerModule, BreadcrumbModule, CategoryNavigationModule, CmsParagraphModule, FooterNavigationModule, HamburgerMenuModule, HomePageEventModule, LinkModule, LoginRouteModule, LogoutModule, MyAccountV2Module, MyCouponsModule, MyInterestsModule, NavigationEventModule, NavigationModule, NotificationPreferenceModule, PageTitleModule, PaymentMethodsModule, PDFModule, ProductCarouselModule, ProductDetailsPageModule, ProductFacetNavigationModule, ProductImagesModule, ProductIntroModule, ProductListingPageModule, ProductListModule, ProductPageEventModule, ProductReferencesModule, ProductSummaryModule, ProductTabsModule, ScrollToTopModule, SearchBoxModule, SiteContextSelectorModule, StockNotificationModule, TabParagraphContainerModule, VideoModule } from "@spartacus/storefront";


import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { TagManagementFeatureModule } from './features/tracking/tag-management-feature.module';


import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer360-feature.module';
import { CdcFeatureModule } from './features/cdc/cdc-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';

import { UserDetailsModule } from '@spartacus/organization/administration/components';
import { ConfigModule } from '@spartacus/core';
import { AsmComponentsModule } from '@spartacus/asm/components';
import { AsmRootModule } from '@spartacus/asm/root';
import { provideConfig } from '@spartacus/core';




@NgModule({
  declarations: [],
  imports: [
    


    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    UserModule,
    UserOccModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    MyAccountV2Module,
    StockNotificationModule,
    MyCouponsModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    PersonalizationFeatureModule,
    TagManagementFeatureModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    CdcFeatureModule,
    SmartEditFeatureModule,
    AsmRootModule,
    AsmComponentsModule,

  ],
  
  providers: [provideFeatureToggles({
    
// Switch to Authorization Code (PKCE) by default
authorizationCodeFlowByDefault: true,
// These are recommended by SAP for the code-flow rollout
//incrementProcessesCountForMergeCart: true,
dispatchLoginActionOnlyWhenTokenReceived: true,
// optional if you use CDC analytics: cdsLoginEventsToken: true,

    // "showPromotionsInPDP": true,
    // "recentSearches": true,
    // "pdfInvoicesSortByInvoiceDate": true,
    // "storeFrontLibCardParagraphTruncated": true,
    // "productConfiguratorAttributeTypesV2": true,
    // "a11yRequiredAsterisks": true,
    // "a11yQuantityOrderTabbing": true,
    // "a11yNavigationUiKeyboardControls": true,
    // "a11yOrderConfirmationHeadingOrder": true,
    // "a11yStarRating": true,
    // "a11yViewChangeAssistiveMessage": true,
    // "a11yReorderDialog": true,
    // "a11yPopoverFocus": true,
    // "a11yScheduleReplenishment": true,
    // "a11yScrollToTop": true,
    // "a11ySavedCartsZoom": true,
    // "a11ySortingOptionsTruncation": true,
    // "a11yExpandedFocusIndicator": true,
    // "a11yCheckoutDeliveryFocus": true,
    // "a11yMobileVisibleFocus": true,
    // "a11yOrganizationsBanner": true,
    // "a11yOrganizationListHeadingOrder": true,
    // "a11yReplenishmentOrderFieldset": true,
    // "a11yListOversizedFocus": true,
    // "a11yStoreFinderOverflow": true,
    // "a11yCartSummaryHeadingOrder": true,
    // "a11yUnitsListKeyboardControls": true,
    // "a11yCartItemsLinksStyles": true,
    // "a11yFocusableCarouselControls": true,
    // "cartQuickOrderRemoveListeningToFailEvent": 
    //authorizationCodeFlowByDefault: true,
  }),
  // provideFeatureTogglesFactory(() => {
  //   const appFeatureToggles: Required<FeatureToggles> = {
  //     authorizationCodeFlowByDefault: true,
  //     a11yUseProperTextColorForFutureStockAccordion: false,
  //     a11yPopoverHighContrast: false,
  //     a11yTabsManualActivation: false,
  //     a11yAnonymousConsentMessageInDialog: false,
  //     a11yQuickOrderSearchListKeyboardNavigation: false,
  //     a11yStyleExternalLinksAsLinks: false,
  //     a11ySelectLabelWithContextForSelectedAddrOrPayment: false,
  //     a11yKeyboardAccessibleZoom: false,
  //     a11yTruncatedTextStoreFinder: false,
  //     a11yTruncatedTextUnitLevelOrderHistory: false,
  //     a11yPreventCartItemsFormRedundantRecreation: false,
  //     a11yResetFocusAfterNavigating: false,
  //     a11yStoreFinderLabel: false,
  //     a11yImprovedErrorMessage: false,
  //     a11yLinkBtnsToTertiaryBtns: false,
  //     a11yNgSelectCloseDropdownOnEscape: false,
  //     a11yNgSelectAriaLabelDropdownCustomized: false,
  //     a11ySelectImprovementsCustomerTicketingCreateSelectbox: false,
  //     a11yStoreInStockIconContrast: false,
  //     a11yImproveButtonsInCardComponent: false,
  //     a11yMiniCartFocusOnMobile: false,
  //     a11yApprovalProcessWithNoClearable: false,
  //     a11yPostRegisterSuccessMessage: false,
  //     a11yShowLabelOfSelect: false,
  //     a11yShowDownArrowOnFocusedSelectMenu: false,
  //     a11yCroppedFocusRing: false,
  //     a11yTextSpacingAdjustments: false,
  //     a11yTableHeaderReadout: false,
  //     a11ySearchboxAssistiveMessage: false,
  //     updateConsentGivenInOnChanges: false,
  //     a11yDifferentiateFocusedAndSelected: false,
  //     a11yQuickOrderSearchBoxRefocusOnClose: false,
  //     a11yKeyboardFocusInSearchBox: false,
  //     a11yAddPaddingToCarouselPanel: false,
  //     a11yNavigationButtonsAriaFixes: false,
  //     a11yFocusOnCardAfterSelecting: false,
  //     a11ySearchableDropdownFirstElementFocus: false,
  //     a11yHideConsentButtonWhenBannerVisible: false,
  //     a11yRepeatingButtonsUniqueLabels: false,
  //     a11yHighContrastBorders: false,
  //     enableClaimCustomerCouponWithCodeInRequestBody: false,
  //     a11yPdpGridArrangement: false,
  //     a11yHamburgerMenuTrapFocus: false,
  //     a11yRegionAssociatedHeaders: false,
  //     showRealTimeStockInPDP: false,
  //     a11yScrollToTopPositioning: false,
  //     a11yWrapReviewOrderInSection: false,
  //     a11yWideScreenImprovements: false,
  //     a11yOptimizedMenuSpacing: false,
  //     a11yNgSelectLayering: false,
  //     readMoreDirective: false,
  //     productReviewCharactersLeft: false,
  //     a11yNgSelectAriaControls: false,
  //     a11yConfiguratorOverviewHeaderVPC: false,
  //     enableCarouselCategoryProducts: false,
  //     enableSecurePasswordValidation: false,
  //     enableReadDomainValuesOnDemand: false,
  //     opfEnablePreventingFromCheckoutWithoutEmail: false,
  //     storeFinderFacadeCleanup: false,
  //     defaultProductPageRouteAllowsNoProductName: false,
  //     consistentSizeProductCards: false,
  //     reserveHorizontalSpaceStarRating: false,
  //     topProgressBarUseTransformAnimation: false,
  //     disableCxPageSlotMarginAnimation: false,
  //     productCarouselScrolling: false,
  //     cdsLoginEventsToken: false,
  //     createMediaPreconnectLink: false,
  //     unifiedDefaultHeaderSlotsAcrossBreakpoints: false,
  //     reserveSpaceForImagesOnPdpAndPlp: false,
  //     lazyLoadImagesByDefault: false,
  //     incrementProcessesCountForMergeCart: false,
  //     dispatchLoginActionOnlyWhenTokenReceived: false,
  //     defaultLayoutConfigWithoutPageFold: false,
  //     navigationMenuCloseOnSameLinkClick: false,
  //     enableQuotePurchaseOrderNumber: false,
  //     enableReturnOrderReturnableQuantityConsigmentFallback: false
  //   };
  //   return appFeatureToggles;
  // }),
]
})

export class SpartacusFeaturesModule { }
